/* src/app/externallogin/externallogin.component.css */
body {
  background-color: #f2f2f2;
}
.reg_bg {
  background: #ffffff url(/assets/images/ots_bg.png) no-repeat center top;
  padding-bottom: 40px;
  text-align: center;
  padding-top: 36px;
}
.index_wrapper {
  margin: 55px 0px 55px 0px;
}
.index_left {
  text-align: left;
  color: #fff;
}
.index_left p {
  font-size: 18px;
  margin-top: 20px;
}
.index_left span {
  font-size: 12px;
  margin-top: 15px;
  float: left;
}
.index_rightmain {
  text-align: left;
}
.index_rightmain strong {
  color: #ffffff;
}
.index_passwordicon {
  float: right;
  margin-top: -34px;
}
.index_forgotpass {
  padding: 15px 0px 0px 0px;
  color: #fff;
  font-size: 12px;
}
.index_forgotpass a {
  color: #ffffff;
}
.index_sso {
  padding: 10px 0px 0px 0px;
  color: #fff;
  font-size: 12px;
}
.index_sso a {
  color: #ffffff;
}
.index_submit {
  padding: 0px;
}
.index_submit {
  background-color: #fff !important;
  color: #000;
  border-radius: 30px;
  margin-top: 16px;
  text-transform: capitalize;
  box-shadow: none !important;
  height: auto;
  line-height: normal;
  padding: 4px 15px;
}
.eye_modify {
  cursor: pointer;
  pointer-events: all;
  color: #000;
  font-size: 18px;
  margin-top: -5px;
}
.input-ErrorField {
  font-size: 12px;
  padding-bottom: 0px;
  margin-bottom: 0px;
  border-bottom-color: #fff !important;
  color: #ea1d25;
  margin-top: 0px;
  position: relative;
  background-color: #00cee7;
  padding: 6px;
}
.createnew-sel {
  display: block;
  border: none;
  border-radius: 0px;
  border-bottom: solid 1px #fff;
  height: 60px;
  font-size: 11px;
  padding-top: 15px;
  color: #8bd0f3;
  width: 100%;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background: transparent url(/assets/images/down_arrow.png) no-repeat right;
  height: 38px;
}
.input-field label {
  font-size: 11px;
  color: #8bd0f3 !important;
  font-weight: normal;
}
.input-field input {
  padding-bottom: 0px;
  margin-bottom: 0px;
  margin-top: 011px;
  border-bottom-color: #000 !important;
  height: 36px;
  width: 382px;
}
input::placeholder,
:-ms-input-placeholder,
::-webkit-input-placeholder,
input::-webkit-input-placeholder {
  color: white !important;
}
.eye_modify {
  font-size: 14px !important;
}
.input-ErrorField {
  color: #cc0000 !important;
}
@media (min-width: 300px) and (max-width: 700px) {
  .index_left {
    text-align: left;
    color: #fff;
    padding-bottom: 20px;
  }
}
/*# sourceMappingURL=externallogin.component.css.map */
